//(function () {
//    'use strict';

//    angular.module("imApp").factory("productViewService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
